export const RETURNS_RESTRICTED_ADMIN_EMAILS = new Set([
  "dev@getredo.com",
  "jordan@getredo.com",
  "aaron@getredo.com",
  "josh.thayne@getredo.com",
  "hugh@getredo.com",
  "sam@getredo.com",
  "tommy.wei@getredo.com",
  "will.schaefermeyer@getredo.com",
  "jacob.olson@getredo.com",
  "steven.mitchell@getredo.com",
  "eric@getredo.com",
  "ridge@getredo.com",
  "dylan.wooden@getredo.com",
  "bryce@getredo.com",
  "greg@getredo.com",
  "sperez@getredo.com",
  "bryson@getredo.com",
  "danny.boyer@getredo.com",
  "manny@getredo.com",
  "harrison.walker@getredo.com",
  "harrison@getredo.com",
  "ryan@getredo.com",
  "kash@getredo.com",
  "spencer.evans@getredo.com",
  "joe.brijs@redo.com",
  "thomas.stansel@redo.com",
  "alexis@getredo.com",
  "seth@getredo.com",
  "parker@getredo.com",
  "ben.kearsley@redo.com",
  "steven.brown@redo.com",
  "woody@redo.com",
  "lauren.favero@redo.com",
]);

export function hasReturnsRestrictedAdminAccess(
  email: string | null | undefined,
): boolean {
  return RETURNS_RESTRICTED_ADMIN_EMAILS.has(email?.trim().toLowerCase() ?? "");
}
